import React from 'react';
import { createRoot } from 'react-dom/client';
import alertUtils, { SWAL } from '../../utils/alert.util';
import cartUtils from '../../utils/cart.utils';
import notificationUtils from '../../utils/notif.util';

const AddToCartAction = ({ productId }) => {
    const addItem = () => {
        try {
            let listItem = [];
            const cartStorage = cartUtils.get();
            if (!cartStorage) {
                cartUtils.set([]);
            } else {
                listItem = JSON.parse(cartStorage);
            }
            if (listItem.length == 0) {
                listItem = [
                    {
                        id: productId,
                        quantity: 1,
                    },
                ];
            } else {
                const objCheck = listItem.find((o) => o.id == productId);
                if (!objCheck) {
                    listItem = [
                        {
                            id: productId,
                            quantity: 1,
                        },
                        ...listItem,
                    ];
                } else {
                    listItem = listItem.map((o) => {
                        if (o.id == productId) {
                            o.quantity = +o.quantity + 1;
                        }
                        return o;
                    });
                }
            }

            cartUtils.set(listItem);

            notificationUtils.success('Thêm vào giỏ hàng thành công');

            // alertUtils.show(
            //     SWAL.TYPE.SUCCESS,
            //     'Thêm sản phẩm vào giỏ hàng thành công'
            // );
        } catch (err) {
            console.log(err);
        }
    };
    return (
        <div className="action">
            <a className="add-cart" title="Add to cart" onClick={addItem}></a>
            <a className="wish" href="#" title="Wishlist"></a>
        </div>
    );
};

AddToCartAction.propTypes = {};

export default AddToCartAction;

document
    .querySelectorAll('react-add-to-cart-action')
    .forEach((domContainer) => {
        const root = createRoot(domContainer);
        const productId = domContainer.dataset.productId;
        root.render(<AddToCartAction productId={productId} />);
    });
